<script setup lang="ts">
/**
 * Field wrapper: `space-y-1.5` + a `text-sm font-medium` label + optional hint.
 * Default slot is the control. Use `labelSize="xs"` for the muted advanced-field
 * label (`text-xs text-muted-foreground`).
 */
defineProps<{
  label?: string
  hint?: string
  /** 'sm' = text-sm font-medium (default), 'xs' = text-xs text-muted-foreground */
  labelSize?: 'sm' | 'xs'
  /**
   * A server refusal about THIS field, rendered under the control (AlexAmin/marcus#304).
   *
   * Below the control and not above it, so it reads as a consequence of the value rather than as an
   * instruction for filling it in — the hint already owns that position. Always a sentence the
   * server wrote, never a code and never a status: a rejection's `message` is user-facing,
   * source-language copy relayed verbatim, so there is no string to translate here.
   */
  error?: string | null
}>()
</script>

<template>
  <div class="min-w-0 space-y-1.5">
    <div v-if="$slots.label || label" :class="labelSize === 'xs' ? 'text-xs text-muted-foreground' : 'text-sm font-medium'">
      <slot name="label">{{ label }}</slot>
    </div>
    <p v-if="$slots.hint || hint" class="text-xs text-muted-foreground">
      <slot name="hint">{{ hint }}</slot>
    </p>
    <slot />
    <p v-if="error" class="text-sm text-destructive">{{ error }}</p>
  </div>
</template>
